import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  CalloutColor,
  CalloutPlacement,
  CalloutViewportFit,
} from '@freelancer/ui/callout';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-find-work-by-skills',
  template: `
    <fl-grid class="ThreeColumns">
      <fl-col
        class="mb-mid"
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Website jobs description"
          description="Website jobs"
          [url]="'/jobs/web-development'"
          [imgSrc]="'logged-out-navigation/find-job/website.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
      <fl-col
        class="mb-mid"
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Graphic design jobs description"
          description="Graphic design jobs"
          [url]="'/jobs/graphic-design'"
          [imgSrc]="'logged-out-navigation/find-job/graphic-design.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
      <fl-col
        class="mb-mid"
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Data entry jobs description"
          description="Data entry jobs"
          [url]="'/jobs/data-entry'"
          [imgSrc]="'logged-out-navigation/find-job/data-entry.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
      <fl-col
        class="mb-mid desktop:mb-none"
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Mobile app development jobs description"
          description="Mobile app development jobs"
          [url]="'/jobs/mobile-phone'"
          [imgSrc]="'logged-out-navigation/find-job/mobile.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
      <fl-col
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Internet marketing jobs description"
          description="Internet marketing jobs"
          [url]="'/jobs/internet-marketing'"
          [imgSrc]="'logged-out-navigation/find-job/internet-marketing.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
      <fl-col
        [col]="6"
        [colTablet]="4"
      >
        <app-navigation-menu-card
          i18n-description="Local jobs description"
          description="Local jobs"
          [url]="'/local'"
          [imgSrc]="'logged-out-navigation/find-job/local.png'"
          [isLoggedOut]="true"
        >
        </app-navigation-menu-card>
      </fl-col>
    </fl-grid>
    <div class="LinksColumn">
      <div class="ViewMoreContainer">
        <p
          class="text-light font-bold mb-mid"
          i18n="Side Bar Title"
        >
          Other popular jobs
        </p>
        <fl-link
          flTrackingLabel="SkillViewMoreLink"
          i18n="View More link"
          class="ViewMoreColor desktop_xlarge:hide"
          [newTab]="false"
          [iconName]="'ui-arrow-forward'"
          [iconPosition]="LinkIconPosition.RIGHT"
          [weight]="LinkWeight.MEDIUM"
          [color]="LinkColor.INHERIT"
          [iconColor]="IconColor.INHERIT"
          (click)="handleSecondLayer()"
        >
          View more
        </fl-link>
      </div>
      <app-navigation-menu-list [list]="hirePopularSkills">
      </app-navigation-menu-list>
      <app-navigation-logged-out-home-section-find-work-by-skills-list
        class="SeoContent"
      >
      </app-navigation-logged-out-home-section-find-work-by-skills-list>
      <fl-link
        flTrackingLabel="SkillViewMoreLink"
        i18n="View More link"
        class="ViewMoreColor desktop_xlarge:show"
        [link]="'/jobs'"
        [newTab]="false"
        [iconName]="'ui-arrow-forward'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [weight]="LinkWeight.MEDIUM"
        [color]="LinkColor.INHERIT"
        [iconColor]="IconColor.INHERIT"
        [iconAnimation]="true"
      >
        View more
      </fl-link>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-sections.component.scss'],
})
export class NavigationLoggedOutHomeSectionFindWorkBySkillsComponent {
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;

  hirePopularSkills = [
    {
      linkDescription: $localize`Software development jobs`,
      linkUrl: '/jobs/software-development',
    },
    {
      linkDescription: $localize`Internet marketing jobs`,
      linkUrl: '/jobs/internet-marketing',
    },
    {
      linkDescription: $localize`Data entry jobs`,
      linkUrl: '/jobs/data-entry',
    },
    {
      linkDescription: $localize`SEO jobs`,
      linkUrl: '/jobs/seo',
    },
    {
      linkDescription: $localize`Writing jobs`,
      linkUrl: '/jobs/writing',
    },
    {
      linkDescription: $localize`Legal jobs`,
      linkUrl: '/jobs/legal',
    },
    {
      linkDescription: $localize`Finance jobs`,
      linkUrl: '/jobs/finance',
    },
    {
      linkDescription: $localize`Manufacturing jobs`,
      linkUrl: '/jobs/manufacturing',
    },
    {
      linkDescription: $localize`Logistics jobs`,
      linkUrl: '/logistics-shipping',
    },
  ];

  @Output() viewSecondLayer = new EventEmitter<void>();

  handleSecondLayer(): void {
    this.viewSecondLayer.emit();
  }
}

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-find-work-by-skills-list',
  template: `
    <app-navigation-menu-list [list]="findJobFullSkillsList">
    </app-navigation-menu-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionFindWorkBySkillsListComponent {
  findJobFullSkillsList = [
    {
      linkDescription: $localize`Graphic Design Jobs`,
      linkUrl: '/jobs/graphic-design',
    },
    {
      linkDescription: $localize`Website Jobs`,
      linkUrl: 'jobs/web-development/',
    },
    {
      linkDescription: $localize`Mobile App Development Jobs`,
      linkUrl: 'jobs/mobile-phone/',
    },
    {
      linkDescription: $localize`Software Development Jobs`,
      linkUrl: 'jobs/software-development/',
    },
    {
      linkDescription: $localize`Internet Marketing Jobs`,
      linkUrl: 'jobs/internet-marketing/',
    },
    {
      linkDescription: $localize`Data Entry Jobs`,
      linkUrl: '/jobs/data-entry',
    },
    {
      linkDescription: $localize`SEO Jobs`,
      linkUrl: '/jobs/seo',
    },
    {
      linkDescription: $localize`Writing Jobs`,
      linkUrl: 'jobs/writing',
    },
    {
      linkDescription: $localize`Legal Jobs`,
      linkUrl: '/jobs/legal',
    },
    {
      linkDescription: $localize`Finance Jobs`,
      linkUrl: '/jobs/finance',
    },
    {
      linkDescription: $localize`Manufacturing Jobs`,
      linkUrl: '/jobs/manufacturing',
    },
    {
      linkDescription: $localize`Logistics Jobs`,
      linkUrl: '/jobs/logistics-shipping',
    },
    {
      linkDescription: $localize`Logo Design Jobs`,
      linkUrl: 'jobs/logo-design',
    },
    {
      linkDescription: $localize`Web Design Jobs`,
      linkUrl: 'jobs/website-design',
    },
    {
      linkDescription: $localize`Banner Design Jobs`,
      linkUrl: 'jobs/banner-design',
    },
    {
      linkDescription: $localize`3D Modeling Jobs`,
      linkUrl: 'jobs/3d-modelling',
    },
    {
      linkDescription: $localize`Photoshop Jobs`,
      linkUrl: 'jobs/photoshop',
    },
    {
      linkDescription: $localize`Illustration Jobs`,
      linkUrl: 'jobs/illustration',
    },
    {
      linkDescription: $localize`3D Animation Jobs`,
      linkUrl: 'jobs/3d-animation',
    },
    {
      linkDescription: $localize`2D Animation Jobs`,
      linkUrl: 'jobs/2d-animation',
    },
    {
      linkDescription: $localize`Other Graphic Design Jobs`,
      linkUrl: 'jobs/graphic-design',
    },
    {
      linkDescription: $localize`PHP Jobs`,
      linkUrl: 'jobs/php/',
    },
    {
      linkDescription: $localize`Javascript Jobs`,
      linkUrl: 'jobs/javascript/',
    },
    {
      linkDescription: $localize`.NET Jobs`,
      linkUrl: 'jobs/dot-net/',
    },
    {
      linkDescription: $localize`CSS Jobs`,
      linkUrl: 'jobs/css/',
    },
    {
      linkDescription: $localize`Amazon Web Services Jobs`,
      linkUrl: 'jobs/amazon-web-services/',
    },
    {
      linkDescription: $localize`HTML5 Jobs`,
      linkUrl: 'jobs/html5/',
    },
    {
      linkDescription: $localize`Wordpress Jobs`,
      linkUrl: 'jobs/wordpress/',
    },
    {
      linkDescription: $localize`Wix Jobs`,
      linkUrl: 'jobs/wix/',
    },
    {
      linkDescription: $localize`Squarespace Jobs`,
      linkUrl: 'jobs/squarespace/',
    },
    {
      linkDescription: $localize`Shopify Jobs`,
      linkUrl: 'jobs/shopify/',
    },
    {
      linkDescription: $localize`Magento Jobs`,
      linkUrl: 'jobs/magento/',
    },
    {
      linkDescription: $localize`Database Development Jobs`,
      linkUrl: 'jobs/database-development/',
    },
    {
      linkDescription: $localize`Other Website Jobs`,
      linkUrl: 'jobs/web-development/',
    },
    {
      linkDescription: $localize`iPhone App Jobs`,
      linkUrl: 'jobs/ios-development/',
    },
    {
      linkDescription: $localize`Android App Jobs`,
      linkUrl: 'jobs/android/',
    },
    {
      linkDescription: $localize`Flutter Jobs`,
      linkUrl: 'jobs/flutter/',
    },
    {
      linkDescription: $localize`Xamarin Jobs`,
      linkUrl: 'jobs/xamarin/',
    },
    {
      linkDescription: $localize`PhoneGap Jobs`,
      linkUrl: 'jobs/phonegap/',
    },
    {
      linkDescription: $localize`Other Mobile App Development Jobs`,
      linkUrl: 'jobs/mobile-phone/',
    },
    {
      linkDescription: $localize`Linux Jobs`,
      linkUrl: 'jobs/linux/',
    },
    {
      linkDescription: $localize`C++ Software Development Jobs`,
      linkUrl: 'jobs/cplusplus-programming/',
    },
    {
      linkDescription: $localize`C# Software Development Jobs`,
      linkUrl: 'jobs/c-sharp-programming/',
    },
    {
      linkDescription: $localize`Objective C Software Development Jobs`,
      linkUrl: 'jobs/objective-c/',
    },
    {
      linkDescription: $localize`Ruby On Rails Software Development Jobs`,
      linkUrl: 'jobs/ruby-on-rails/',
    },
    {
      linkDescription: $localize`Python Software Development Jobs`,
      linkUrl: 'jobs/python/',
    },
    {
      linkDescription: $localize`Java Software Development Jobs`,
      linkUrl: 'jobs/java/',
    },
    {
      linkDescription: $localize`Other Software Development Jobs`,
      linkUrl: 'jobs/software-development/',
    },
    {
      linkDescription: $localize`Social Media Marketing Jobs`,
      linkUrl: 'jobs/social-media-marketing/',
    },
    {
      linkDescription: $localize`Other Internet Marketing Jobs`,
      linkUrl: 'jobs/internet-marketing',
    },
    {
      linkDescription: $localize`Copywriting Jobs`,
      linkUrl: 'jobs/copywriting',
    },
    {
      linkDescription: $localize`Ghostwriting Jobs`,
      linkUrl: 'jobs/ghostwriting',
    },
    {
      linkDescription: $localize`Article Writing Jobs`,
      linkUrl: 'jobs/articles',
    },
    {
      linkDescription: $localize`Other Writing Jobs`,
      linkUrl: 'jobs/writing',
    },
  ];
}

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-find-work-by-languages',
  template: `
    <div class="LinksColumn">
      <p
        class="text-light font-bold mb-mid"
        i18n="Side Bar Title"
      >
        Find work in different languages
      </p>
      @for (language of languages; track trackByDescription($index, language)) {
        <fl-link
          class="mb-small"
          flTrackingLabel="languageLink"
          [link]="language.linkUrl"
          [queryParams]="{ languages: language.languageCode }"
          [color]="LinkColor.LIGHT"
          [newTab]="false"
        >
          {{ language.linkDescription }}
        </fl-link>
      }

      <fl-link
        flTrackingLabel="languageViewMoreLink"
        i18n="View more link"
        class="ViewMoreColor"
        [link]="'/jobs'"
        [newTab]="false"
        [iconName]="'ui-arrow-forward'"
        [iconPosition]="LinkIconPosition.RIGHT"
        [weight]="LinkWeight.MEDIUM"
        [color]="LinkColor.INHERIT"
        [iconColor]="IconColor.INHERIT"
        [iconAnimation]="true"
      >
        View more
      </fl-link>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-sections.component.scss'],
})
export class NavigationLoggedOutHomeSectionFindWorkByLanguagesComponent {
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  IconColor = IconColor;

  languages: readonly {
    linkDescription: string;
    linkUrl: string;
    languageCode: string;
  }[] = [
    {
      linkDescription: $localize`Jobs in English`,
      linkUrl: '/jobs',
      languageCode: 'en',
    },
    {
      linkDescription: $localize`Jobs in Spanish`,
      linkUrl: '/jobs',
      languageCode: 'es',
    },
    {
      linkDescription: $localize`Jobs in Portugese`,
      linkUrl: '/jobs',
      languageCode: 'pt',
    },
    {
      linkDescription: $localize`Jobs in French`,
      linkUrl: '/jobs',
      languageCode: 'fr',
    },
    {
      linkDescription: $localize`Jobs in German`,
      linkUrl: '/jobs',
      languageCode: 'de',
    },
    {
      linkDescription: $localize`Jobs in Hindi`,
      linkUrl: '/jobs',
      languageCode: 'hi',
    },
    {
      linkDescription: $localize`Jobs in Chinese`,
      linkUrl: '/jobs',
      languageCode: 'zh',
    },
    {
      linkDescription: $localize`Jobs in Japanese`,
      linkUrl: '/jobs',
      languageCode: 'ja',
    },
  ];

  trackByDescription(_: number, language: { linkDescription: string }): string {
    return language.linkDescription;
  }
}

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-find-work',
  template: `
    <fl-callout
      class="Callout"
      [edgeToEdge]="true"
      [placement]="CalloutPlacement.BOTTOM_LEFT"
      [hideCloseButton]="true"
      [hover]="true"
      [viewportFit]="viewportFit"
      [crawlable]="true"
      [color]="CalloutColor.DARK"
      (calloutOpen)="openCalloutHandler()"
      (calloutClose)="closeCalloutHandler()"
    >
      <fl-callout-trigger class="Callout">
        <fl-link
          class="NavigationItem mr-small mobile:hide tablet:hide"
          flTrackingLabel="Hirefreelancers"
          i18n="Navigation hire freelancers label"
          [class.IsCalloutOpen]="isCalloutOpen"
          [iconName]="'ui-chevron-down'"
          [iconSize]="IconSize.MID"
          [iconColor]="IconColor.INHERIT"
          [iconPosition]="LinkIconPosition.RIGHT"
          [size]="TextSize.BODY_16"
          [color]="LinkColor.LIGHT"
          [underline]="LinkUnderline.NEVER"
        >
          Find work
        </fl-link>
      </fl-callout-trigger>
      <fl-callout-content>
        <div class="CalloutContent">
          <div class="NavContainer">
            <app-navigation-menu-nav-item
              i18n-titleLink="Find Work by skill navigation item title text"
              titleLink="By skill"
              i18n-description="By skill navigation item description text"
              description="
              Search for work that requires a particular skill.
            "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [contentId]="'skill'"
              [iconName]="'ui-person-brain'"
              [iconArrowColor]="IconColor.LIGHT"
              [isActive]="selectedTab === 'skill'"
              (hover)="selectTab($event)"
            ></app-navigation-menu-nav-item>
            <app-navigation-menu-nav-item
              class="mb-xxxsmall"
              i18n-titleLink="By language navigation item title text"
              titleLink="By language"
              i18n-description="By language navigation item description text"
              description="Find projects that are in your language."
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [contentId]="'language'"
              [iconName]="'ui-globe'"
              [iconArrowColor]="IconColor.LIGHT"
              [isActive]="selectedTab === 'language'"
              (hover)="selectTab($event)"
            ></app-navigation-menu-nav-item>
            <app-navigation-menu-nav-item
              i18n-titleLink="Featured jobs navigation item title text"
              titleLink="Featured jobs"
              i18n-description="Featured jobs navigation item description text"
              description="
                Explore our current list of excited top featured projects.
              "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [iconName]="'ui-bookmark-v2'"
              [iconArrow]="false"
              [url]="'/jobs?featured=true'"
            ></app-navigation-menu-nav-item>
            <app-navigation-menu-nav-item
              i18n-titleLink="Find contests navigation item title text"
              titleLink="Find contests"
              i18n-description="Find contests navigation item description text"
              description="
                Unleash your talent and find freelancer contests to enter.
              "
              [descriptionColor]="FontColor.LIGHT"
              [isLoggedOut]="true"
              [iconName]="'ui-trophy'"
              [iconArrow]="false"
              [url]="'/contest'"
            ></app-navigation-menu-nav-item>
          </div>
          <div class="SidePanel">
            <div
              id="skill"
              class="GridContainer"
              [class.IsActive]="selectedTab === 'skill'"
            >
              <app-navigation-logged-out-home-section-find-work-by-skills />
            </div>
            <div
              id="language"
              class="GridContainer"
              [class.IsActive]="selectedTab === 'language'"
            >
              <app-navigation-logged-out-home-section-find-work-by-languages />
            </div>
          </div>
        </div>
      </fl-callout-content>
    </fl-callout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-base-callouts.component.scss'],
})
export class NavigationLoggedOutHomeSectionFindWorkComponent {
  CalloutPlacement = CalloutPlacement;
  CalloutColor = CalloutColor;
  IconColor = IconColor;
  IconSize = IconSize;
  FontColor = FontColor;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkUnderline = LinkUnderline;
  TextSize = TextSize;

  // Enabling viewportFit stops the callout from being cut off on smaller
  // viewports when the side panel is open
  viewportFit: CalloutViewportFit = { enabled: true };

  isCalloutOpen = false;
  defaultTab = 'skill';
  selectedTab?: string | undefined = this.defaultTab;

  selectTab(tab: string | undefined): void {
    this.selectedTab = tab;
  }

  openCalloutHandler(): void {
    this.isCalloutOpen = true;
  }

  closeCalloutHandler(): void {
    this.isCalloutOpen = false;
    this.selectedTab = this.defaultTab;
  }
}
